import { Api } from '@/services/Api'

export default {
     /*  1. Get all data */
    getManageOperatingRequestsByCriteria(body = { keyword: '' }) {
        return Api().post('/ManageOperatingRequests/GetManageOperatingRequestsByCriteria', body)
    },
     /*  2. Get one column */
    getManageOperatingRequests(id) {
        return Api().get(`/ManageOperatingRequests/${id}`);
    },
     /*  3. Create one column */
    saveManageOperatingRequests(body) {
        return Api().post(`/ManageOperatingRequests`, body);
    },
    /*  4. Delete one or more columns */
    deleteManageOperatingRequests(manageOperatingRequests) {
        return Api().post(`/ManageOperatingRequests/DeleteManageOperatingRequests`, manageOperatingRequests);
    },
    /*  5. post one or more columns */
    postManageOperatingRequests(manageOperatingRequests) {
        return Api().post(`/ManageOperatingRequests/PostManageOperatingRequests`, manageOperatingRequests);
    },
    startWF(body) {
        return Api().post(`/ManageOperatingRequests/StartWF`, body);
    }
}